import { createRouter, createWebHashHistory } from 'vue-router';

import baseModule from './baseRoutes';
import ordersModule from './orderRoutes';
import loginRoute from './loginRoutes';
import menuModule from './menuRoutes';
import financeModule from './financeRoutes';
import reportsModule from './reportRoutes';
import discountRoutes from './discountRoutes';

const defaultRoute = {
	path: '/:catchAll(.*)',
	component: () => import('../views/NotFoundView'),
	meta: {
		title: 'Oops',
	},
};

const routes = [
	baseModule,
	financeModule,
	ordersModule,
	loginRoute,
	menuModule,
	discountRoutes,
	defaultRoute,
	reportsModule,
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

function nextFactory(context, middleware, index) {
	const subsequentMiddleware = middleware[index];
	if (!subsequentMiddleware) return context.next;

	return (...parameters) => {
		context.next(...parameters);
		const nextMiddleware = nextFactory(context, middleware, index + 1);
		subsequentMiddleware({ ...context, next: nextMiddleware });
	};
}

router.beforeEach((to, from, next) => {
	if (to.meta['title']) {
		document.title = `${to.meta['title']} | Baboon POS`;
	} else {
		document.title = `Baboon POS`;
	}
	if (to.meta['middleware']) {
		const middleware = Array.isArray(to.meta['middleware']) ? to.meta['middleware'] : [to.meta['middleware']];

		const context = {
			from,
			next,
			router,
			to,
		};
		const nextMiddleware = nextFactory(context, middleware, 1);

		middleware[0]({ ...context, next: nextMiddleware });
	} else {
		next();
	}
});

export default router;
